/** Web / non-native: no-op. */
export type InitCallKeepContext = 'ui' | 'headless';

export async function initCallKeep(_context: InitCallKeepContext = 'ui'): Promise<void> {
  /* noop */
}

export async function refreshCallKeepRingtone(): Promise<void> {
  /* noop */
}
